bq.global.maskSetup = function() {
  var percentage = '.percentage';

  $(percentage).inputmask("decimal", {
    radixPoint: ".",
    groupSeparator: ",",
    autoGroup: true,
    suffix: "%",
    clearMaskOnLostFocus: true,
    digits: 2, 
    placeholder: "",
    rightAlign: false,
    showMaskOnHover: false,
    showMaskOnFocus: false,
  });
};

bq.init.push(bq.global.maskSetup);